import _pluralize from 'pluralize'

export default {
  install(Vue) {

    const methods = {
      buildDownload(filename, blob) {
        const data = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = data
        link.download = filename
        link.click()
        link.remove()
      },
      capitalize(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
      },
      clone(data) {
        return JSON.parse(JSON.stringify(data))
      },
      downloadByLink(url) {
        const link = window.document.createElement('a')
        link.href = url
        link.rel = 'noopener'
        window.document.body.appendChild(link)
        link.click()
        link.remove()
      },
      fixDate(data) {
        let query = data.q
        if (!query)
          return

        let startDate = query.startDate
        if (startDate && startDate.length < 11) {
          let [year, month, day] = startDate.split('-')
          day = day || 1

          query.startDate = new Date(Date.UTC(year, month -1, day, 0, 0, 0))
        }
        let endDate = query.endDate
        if (endDate && endDate.length < 11) {
          let [year, month, day] = endDate.split('-')

          let date
          if (day) {
            date = Date.UTC(year, month -1, day, 23, 59, 59, 999)
          } else {
            date = Date.UTC(year, month, 0, 23, 59, 59, 999)
          }

          query.endDate = new Date(date)
        }
      },
      pluralize(word, number) {
        return _pluralize(word, number)
      },
      sanitize(data) {
        data = preSanitize(data)
        return data
      },
      toCamelcase: function (data) {
        return preParse(data, toCamelcase)
      },
      toDatetime(date) {
        if (typeof date === 'string')
          date = new Date(date)

        return  date.getUTCDate().toString().padStart(2, '0') + '/' +
          (date.getMonth() +1).toString().padStart(2, '0') + '/' +
          date.getFullYear().toString().padStart(4, '0') + ' ' +
          date.getHours().toString().padStart(2, '0') + ':' +
          date.getMinutes().toString().padStart(2, '0') + ':' +
          date.getSeconds().toString().padStart(2, '0')
      },
      toHashcode(obj) {
        let string = typeof obj === 'string' ? obj : JSON.stringify(obj)
        let hash = 0, i, chr

        for (i = 0; i < string.length; i++) {
          chr   = string.charCodeAt(i)
          hash  = ((hash << 5) - hash) + chr
          hash |= 0; // Convert to 32bit integer
        }
        return hash
      },
      toSnakecase(data) {
        return preParse(data, toSnackcase)
      }
    }

    Vue.parse = methods
    Vue.prototype.$parse = methods
  }
}

function recursive(data, callback) {

  if (Array.isArray(data))
    data.forEach(d => recursive(d, callback))
  else if (data && typeof data == 'object') {
    Object.entries(data).forEach(([key, value]) => {
      // eslint-disable-next-line no-prototype-builtins
      if (data.hasOwnProperty(key)) {
        let newKey = callback(key)
        if (newKey !== key) {
          data[newKey] = value
          delete data[key]
        }
        recursive(value, callback)
      }
    })
  }
}

function toCamelcase(key) {
  return key.replace(/(_\w)/g, (k) => k[1].toUpperCase())
}

function toSnackcase(key) {
    return key.replace(/[\w]([A-Z])/g, (m) => m[0] + '_' + m[1]).toLowerCase()
}

function preSanitize(data) {
  if (Array.isArray(data))
    return sanitizeArray(data)
  else if (data && typeof data === 'object')
    return sanitizeObject(data)
  else
    return data
}

function sanitizeArray(data) {
  const newArray = [];

  data.forEach(value => {
    let newValue;
    if (Array.isArray(value)) {
      newValue = sanitizeArray(value)
      if (newValue.length > 0) newArray.concat(newValue)
    } else if (value && typeof value === 'object') {
      newValue = sanitizeObject(value)
      if (Object.keys(newValue).length > 0) newArray.push(newValue)
    } else if (value){
      newArray.push(value)
    }
  })

  return newArray
}

function sanitizeObject(data) {
  const newObject = {}

  Object.entries(data).forEach(([key, value]) => {
    let newValue;
    if (Array.isArray(value)) {
      newValue = sanitizeArray(value)
      if (newValue.length > 0) newObject[key] = newValue
    } else if (value && typeof value === 'object') {
      newValue = sanitizeObject(value)
      if (Object.keys(newValue).length > 0) newObject[key] = newValue
    } else if (value || typeof value === 'boolean') {
      newObject[key] = value
    }
  })
  return newObject
}

function preParse(data, callback) {
  if (data && typeof data === 'object') {
    let newData = clone(data)
    recursive(newData, callback)
    return newData
  } else if (typeof data == 'string') {
    return callback(data)
  }
}

function clone(data) {
  if (Array.isArray(data))
    return [...data]
  else
    return {...data}
}
